import {createContext, useContext, useEffect, useState} from 'react';
import {useLocation} from "react-router-dom";
import {PRODUCTION_MODE} from "../helpers/Functions";
import {detectPathUrl} from "../helpers/detectPathUrl";

const NavigationContext = createContext();
export const NavigationProvider = (props) => {
    const { pathname } = useLocation();
    const [navStatus, setNavStatus] = useState(false);
    const [nfcError, setNfcError] = useState(false);
    const [nfcNotSupported, setNfcNotSupported] = useState(false);

    const [navigationVisibility, setNavigationVisibility] = useState('show');
    const [scanButton, setScanButton] = useState(true);
    useEffect(()=>{
        const hideRoutes = [detectPathUrl('app/report'), detectPathUrl('app/edit'),
            detectPathUrl('app/faq')];
        const result = hideRoutes.filter((item) => item === pathname).length > 0 ?
            'hide' : 'show';
        setNavigationVisibility(result)
        // console.log(result)

    },[pathname])
    return (
        <NavigationContext.Provider
            value={{
                navStatus,
                setNavStatus,
                nfcError,
                setNfcError,
                navigationVisibility,
                setNavigationVisibility,
                scanButton,
                setScanButton,
                nfcNotSupported,
                setNfcNotSupported

            }}
        >
            {props.children}
        </NavigationContext.Provider>
    );
};
export const useNavigationContext = () => useContext(NavigationContext);
